import { Component, OnInit, ViewChild } from '@angular/core';
import { NgbModal, ModalDismissReasons } from '@ng-bootstrap/ng-bootstrap';
import { Router } from '@angular/router';
import { ApiService } from '../../../core/api.service';
import { UtilityService } from '../../../core/global/utility.service';
import { NgbDate, NgbCalendar } from '@ng-bootstrap/ng-bootstrap';
import * as moment from 'moment';
declare var $: any;
@Component({
  selector: 'app-user-dashboard',
  templateUrl: './user-dashboard.component.html',
  styleUrls: ['./user-dashboard.component.sass']
})
export class UserDashboardComponent implements OnInit {
  public pieChartsevOptions = {
    scaleShowVerticalLines: false,
    responsive: true,
  };
  public pieChartsevLabels = ['open', 'in-progress', 'close'];
  public pieChartsevType = 'doughnut';
  public pieChartsevLegend = true;
  public pieChartsevData = [
    {
      data: [], label: 'By Category', backgroundColor: ['#4382BB', '#F7CE76', '#DC828F', '#8DA47E', '#90CDC3', '#9AD9DB', '#D29FBC', '#WEB96AA', '#A15098', '#C6AC85', '#828288', '#897C87', '#CA9c95', '#F6AE99', '#EDF6E5', '#6F69AC', '#D9CAB3', '#F5ABC9', '#BEA4C8', '#FFC2B8', '#4382BB', '#F7CE76', '#DC828F', '#8DA47E', '#90CDC3', '#9AD9DB', '#D29FBC', '#WEB96AA', '#A15098', '#C6AC85', '#828288', '#897C87', '#CA9c95', '#F6AE99', '#EDF6E5', '#6F69AC', '#D9CAB3', '#F5ABC9', '#BEA4C8', '#FFC2B8'],
      borderColor: '#000',
      borderWidth: 0,
      hoverBackgroundColor: ['#4382BB', '#F7CE76', '#DC828F', '#8DA47E', '#90CDC3', '#9AD9DB', '#D29FBC', '#WEB96AA', '#A15098', '#C6AC85', '#828288', '#897C87', '#CA9c95', '#F6AE99', '#EDF6E5', '#6F69AC', '#D9CAB3', '#F5ABC9', '#BEA4C8', '#FFC2B8', '#4382BB', '#F7CE76', '#DC828F', '#8DA47E', '#90CDC3', '#9AD9DB', '#D29FBC', '#WEB96AA', '#A15098', '#C6AC85', '#828288', '#897C87', '#CA9c95', '#F6AE99', '#EDF6E5', '#6F69AC', '#D9CAB3', '#F5ABC9', '#BEA4C8', '#FFC2B8']
    }
  ];
  public piechartOption = {
    responsive: true,
    scales: {
      yAxes: [
        {
          ticks: {
            beginAtZero: true,
            max: 50

          }
        }
      ],
      xAxes: [{
        barPercentage: 2
      }]
    }
  }
  userType;
  orgList = [];
  gateList = [];
  catcount;
  type = ''
  limit = 10;
  orgCount
  gateCount
  userCount
  userCountOrg
  userCountGate
  searchInput = '';
  sortedtby = 'id';
  org_ref_id = ''
  search = '';
  gate_ref_id = ''
  org_name = '';
  gate_name: any;
  status
  isShown: boolean = true;
  isShown2: boolean = true;
  userList = [];
  sorttype: any = 'asc'
  page: number = 1; // Enter 1 if you want to use the server side pagination 
  p;
  count: any;
  totalPages = [];
  last: any;
  org_id = '';
  gate_id = '';
  selected_Day = "1";
  selected_Dining = "1";
  userCountbyDay = 0;
  diningUserCount = 0;
  loggedCount = 0;
  loggedDiningCount = 0;
  start_date: any;
  day_1_date: any;
  day_2_date: any;
  day_3_date: any;
  org_date: Date;
  backData: any
  constructor(calendar: NgbCalendar, private _adminService: ApiService, private _utility: UtilityService, private router: Router,) { }
  ngOnInit(): void {
    this.org_ref_id = ''
    this.gate_ref_id = ''
    this.isShown = false
    this.isShown2 = false
    this.backData = window.sessionStorage.getItem('event_id')
    this.backData = (this.backData ? JSON.parse(this.backData) : {})
    this.getOrg()
    this.getDashboard()
    this.getUserLog()
    this.getDashboardCount()
  }
  paginate(page) {
    this.page = page;
    this.getUserLog();
  }
  Dining(val) {
    if (val == 1) {
      return 'Breakfast'
    }
    if (val == 2) {
      return 'Lunch'
    }
    if (val == 3) {
      return 'Conversations Over Kahwa'
    }
    if (val == 4) {
      return 'Dinner'
    }
  }
  getUserLog() {
    let wheredata = []
    if (this.org_id != '') {
      let orgData = { 'field': '`qr_user_log`.`org_ref_id`', 'value': this.org_id, 'type': 'AND', 'nested': '' };
      wheredata.push(orgData);
    };
    if (this.gate_id != '') {
      let gateData = { 'field': '`qr_user_log`.`gate_no`', 'value': this.gate_id, 'type': 'AND', 'nested': '' };
      wheredata.push(gateData);
    };
    let url = "qr/user_log_Admin_list";
    let data = { searchText: this.search, sortby: this.sortedtby, sorttype: this.sorttype, page: this.page, limit: this.limit, whereData: wheredata };
    this._utility.showLoader();
    this._adminService.post(url, data).subscribe((response) => {
      this._utility.hideLoader();
      if (response.status == 200) {
        this.userList = response.data;
        this.count = response.total;
        this.limit = response.limit;
        for (var j = 0; j < response.pages; j++) {
          this.totalPages[j] = j + 1;
        }
        this.last = response.pages;
      } else {
        this._utility.toastError(response.message);
      }
    })
  }

  roundUp(n) {
    if (n == 0) {
      n = 10;
    }
    else if (n % 2 == 1) {
      return n = n + 1
    }
    return Math.ceil(n / 5) * 5;
  }

  getOrg() {
    let data = { searchText: this.searchInput, sortby: this.sortedtby, page: this.page };
    let url = "qr/org_list";
    this._adminService.post(url, data).subscribe((response) => {
      if (response.success == true) {
        if (response.data.length > 0) {
          this.orgList = response.data
          this.org_ref_id = response.data[0].id
          if (this.backData.org_id) {
            this.org_ref_id = this.backData.org_id
          }
          this.onOrgChange(this.org_ref_id)

        }
      }
    })
  }

  getGate(org_ref_id) {
    this.gateList = []
    this.gate_ref_id = ''
    this.userCountGate = 0
    this.userCountbyDay = 0
    this.diningUserCount = 0
    this.gate_name = ''
    let wheredata = [{ 'field': '`qr_gate`.`org_ref_id`', 'value': org_ref_id, 'type': 'WHERE', 'nested': '' },
    ]
    let data = { searchText: this.searchInput, sortby: this.sortedtby, page: this.page, whereData: wheredata };
    let url = "qr/gate_list";
    this._adminService.post(url, data).subscribe((response) => {
      if (response.success == true) {
        if (response.data.length > 0) {
          this.gateList = response.data
          this.gate_ref_id = response.data[0].id
          if (this.backData.gate_ref_id) {
            this.gate_ref_id = this.backData.gate_ref_id
          }
          this.onGateChange(this.gate_ref_id)
        }
      }
    })
  }

  onOrgChange(event) {
    this.org_ref_id = event
    let data = { org_ref_id: event }
    let org = this.orgList.filter(el => el.id == event)
    let date = new Date(org[0].start_date)
    this.day_1_date = { year: date.getFullYear(), month: (date.getMonth() + 1), day: date.getDate() }
    this.day_2_date = { year: date.getFullYear(), month: (date.getMonth() + 1), day: date.getDate() + 1 }
    this.day_3_date = { year: date.getFullYear(), month: (date.getMonth() + 1), day: date.getDate() + 2 }
    this.org_date = this.day_1_date
    this.dateChange()
    this.org_name = (org.length > 0 ? org[0].org_name : '')
    let url = "qr/org_userlog";
    this._adminService.post(url, data).subscribe((response) => {
      if (response.success == true) {
        this.userCountOrg = response.countUser
        this.isShown = true
        this.getGate(event)
      }
    })
  }

  onGateChange(event) {
    let data = { gate_ref_id: event, org_ref_id: this.org_ref_id }
    let gate = this.gateList.filter(el => el.id == event)
    this.gate_name = (gate.length > 0 ? gate[0].gate_name : '')
    let url = "qr/gate_userlog";
    this._adminService.post(url, data).subscribe((response) => {
      if (response.success == true) {
        this.userCountGate = response.countUser
        this.userCountbyDay = response.dayUserCount
        this.diningUserCount = response.diningUserCount
        this.selected_Day = "1";
        this.selected_Dining = "1";
        if (this.backData.selected_Day) {
          this.selected_Day = this.backData.selected_Day
        }
        if (this.backData.selected_Dining) {
          this.selected_Dining = this.backData.selected_Dining
        }
        this.isShown2 = true
        this.getLogByDay()
        this.getLogByDinning()
      }
    })
  }

  onDayChange(event) {
    if (event == 1) {
      this.org_date = this.day_1_date
    }
    if (event == 2) {
      this.org_date = this.day_2_date
    }
    if (event == 3) {
      this.org_date = this.day_3_date
    }
    this.selected_Day = event
    this.dateChange()
    let data = { org_ref_id: this.org_ref_id, gate_ref_id: this.gate_ref_id, day: event }
    let url = "qr/day_userlog";
    this._adminService.post(url, data).subscribe((response) => {
      if (response.success == true) {
        this.userCountbyDay = response.dayUserCount
        this.selected_Dining = "1";
        this.diningUserCount = response.diningUserCount
        this.getLogByDay()
        this.getLogByDinning()
      }
    })
  }
  dateChange() {
    let mysqlformatDate = this.org_date['year'] + '-' + ('0' + this.org_date['month']).slice(-2) + '-' + ('0' + this.org_date['day']).slice(-2);
    this.start_date = mysqlformatDate;
  }
  onDiningChange(event) {
    this.selected_Dining = event
    let data = { org_ref_id: this.org_ref_id, dining: event, gate_ref_id: this.gate_ref_id, day: this.selected_Day }
    let url = "qr/dining_userlog";
    this._adminService.post(url, data).subscribe((response) => {
      if (response.success == true) {
        this.diningUserCount = response.diningUserCount
        this.getLogByDinning()
      }
    })
  }

  getDashboard() {
    let data = {}
    let url = "qr/user_dashboard";
    this._adminService.post(url, data).subscribe((response) => {
      if (response.success == true) {
        this.catcount = response.count
        this.pieChartsevLabels = response.org_names
        this.pieChartsevType = 'doughnut';
        this.pieChartsevLegend = true;
        this.pieChartsevData = [
          { data: this.catcount, label: 'By Category', backgroundColor: ['#4382BB', '#F7CE76', '#DC828F', '#8DA47E', '#90CDC3', '#9AD9DB', '#D29FBC', '#WEB96AA', '#A15098', '#C6AC85', '#828288', '#897C87', '#CA9c95', '#F6AE99', '#EDF6E5', '#6F69AC', '#D9CAB3', '#F5ABC9', '#BEA4C8', '#FFC2B8'], borderColor: '#000', borderWidth: 0, hoverBackgroundColor: ['#4382BB', '#F7CE76', '#DC828F', '#8DA47E', '#90CDC3', '#9AD9DB', '#D29FBC', '#WEB96AA', '#A15098', '#C6AC85', '#828288', '#897C87', '#CA9c95', '#F6AE99', '#EDF6E5', '#6F69AC', '#D9CAB3', '#F5ABC9', '#BEA4C8', '#FFC2B8'] }
        ];
      }
    })
  }

  getDashboardCount() {
    let data = {}
    let url = "qr/dashboard";
    this._adminService.post(url, data).subscribe((response) => {
      if (response.success == true) {
        this.orgCount = response.countOrg
        this.gateCount = response.countGate
        this.userCount = response.countUser
      }
    })
  }
  onEventChange(value: any) {
    this.org_id = value;
    this.page = 1;
    this.getUserLog();

  }
  onGatesChange(value: any) {
    this.gate_id = value;
    this.page = 1;
    this.getUserLog();
  };
  toggleShow(toggle) {
    let backdata = {
      org_id: this.org_ref_id,
      gate_ref_id: this.gate_ref_id,
      selected_Day: this.selected_Day,
      selected_Dining: this.selected_Dining
    }
    window.sessionStorage.setItem('event_id', JSON.stringify(backdata))

    if (toggle == 1 && this.org_ref_id != '') {
      this.router.navigateByUrl('/org' + '/user-details/' + this.org_ref_id);
    } if (toggle == 2 && this.gate_ref_id != '') {
      this.router.navigateByUrl('/gate' + '/user-details/' + this.gate_ref_id);
    } if (toggle == 3 && this.gate_ref_id != '') {
      this.router.navigateByUrl('/gate-' + this.selected_Day + '/user-details/' + this.gate_ref_id + `?event_start='${this.start_date}'`);
    } if (toggle == 4 && this.gate_ref_id != '') {
      this.router.navigateByUrl('/gate-' + this.selected_Day + '-' + this.selected_Dining + '/user-details/' + this.gate_ref_id + `?event_start='${this.start_date}'`);
    }
  }
  redirectToAssign(toggle) {
    let backdata = {
      org_id: this.org_ref_id,
      gate_ref_id: this.gate_ref_id,
      selected_Day: this.selected_Day,
      selected_Dining: this.selected_Dining
    }
    let param = `event=${this.org_ref_id}`
    let paramGate = `&gate=${this.gate_ref_id}`
    let paramDay = `&day=${this.selected_Day}`
    let paramDining = `&dining=${(this.selected_Dining)}`
    window.sessionStorage.setItem('event_id', JSON.stringify(backdata))

    if (toggle == 2 && this.gate_ref_id != '') {
      param = param.concat(paramGate)
    }
    if (toggle == 3 && this.selected_Day != '') {
      param = param.concat(paramGate, paramDay, paramDining)
    }
    this.router.navigateByUrl('/assign-role' + `?${param}`);
  }
  date(date) {
    if (date == '1') {
      return moment().format("YYYY-MM-DD")
    }
    if (date == '2') {
      return moment().add(1, 'days').format("YYYY-MM-DD")
    }
    if (date == '3') {
      return moment().add(2, 'days').format("YYYY-MM-DD")
    }
  }
  getLogByDay() {
    let url = "qr/user_log_by_day";
    let wheredata = []
    wheredata = [
      { 'field': '`qr_user_log`.`gate_no`', 'value': this.gate_ref_id, 'type': 'WHERE', 'nested': '' },
      { 'field': '`qr_user_log`.`approved_status`', 'value': '1', 'type': 'AND', 'nested': '' },
      { 'field': "DATE_FORMAT(`qr_user_log`.`created_at`, '%Y-%m-%d')", 'value': this.start_date, 'type': 'AND', 'nested': '' }
    ]
    let data = { searchText: this.searchInput, sortby: this.sortedtby, sorttype: this.sorttype, page: this.page, whereData: wheredata, gate: this.gate_ref_id, day: this.selected_Day, date: this.start_date };
    this._utility.showLoader();
    this._adminService.post(url, data).subscribe((response) => {
      this._utility.hideLoader();
      if (response.status == 200) {
        this.loggedCount = response.data.length

      } else {
        this._utility.toastError(response.message);
      }
    })
  }
  getLogByDinning() {
    let url = "qr/user_log_by_day";
    let wheredata = []
    wheredata = [
      { 'field': '`qr_user_log`.`gate_no`', 'value': this.gate_ref_id, 'type': 'WHERE', 'nested': '' },
      { 'field': '`qr_user_log`.`approved_status`', 'value': '1', 'type': 'AND', 'nested': '' },
      { 'field': "DATE_FORMAT(`qr_user_log`.`created_at`, '%Y-%m-%d')", 'value': this.start_date, 'type': 'AND', 'nested': '' }
    ]
    let data = { searchText: this.searchInput, sortby: this.sortedtby, sorttype: this.sorttype, page: this.page, whereData: wheredata, gate: this.gate_ref_id, day: this.selected_Day, dining: this.selected_Dining, date: this.start_date };
    this._utility.showLoader();
    this._adminService.post(url, data).subscribe((response) => {
      this._utility.hideLoader();
      if (response.status == 200) {
        this.loggedDiningCount = response.data.length
      } else {
        this._utility.toastError(response.message);
      }
    })
  }
}

